export let ApiUrl;
export let SijilatUrl;
// export let GraphiQLUrl;
export let PaymentUrl;
export let AWS_region;
export let AWS_UserPoolId;
export let AWS_ClientId;
export let aws_cognito;
export let QRVerifyUrl;
export let QuadrabayUrl;
export let HCF_URL;
export let WEBSITE_URL;
// console.log('>> process.env.REACT_APP_HOST_ENV,NODE_ENV', process.env.REACT_APP_HOST_ENV, process.env.NODE_ENV);
switch ('production') {
    case 'development':
        ApiUrl = 'https://kyqy0sxuy5.execute-api.eu-west-1.amazonaws.com/Prod';
         HCF_URL = 'https://d1qjr7ikpy4ije.cloudfront.net/api';
        //  HCF_URL = 'http://localhost:3000/api'
        SijilatUrl = 'https://slzp68l5j6.execute-api.eu-west-1.amazonaws.com/Prod';
        PaymentUrl = 'https://lfbxwtz3w4.execute-api.eu-west-1.amazonaws.com/Prod';
        QRVerifyUrl = "https://w5cm0c4xag.execute-api.eu-west-1.amazonaws.com/Prod/public/api";
        QuadrabayUrl = "https://testapi.quadrabayapps.com/api";
        WEBSITE_URL = 'https://d26x43rm06hdzh.cloudfront.net/';
        aws_cognito = {
            'aws_cognito_identity_pool_id': 'eu-west-1:b675f1e7-7488-4be0-844b-7443669de3bd',
            'aws_cognito_region': 'eu-west-1',
            'aws_sign_in_enabled': 'enable',
            'aws_user_files': 'enable',
            'aws_user_files_s3_bucket': 'nhra-users-file-storage-dev-bucket',
            'aws_user_files_s3_bucket_region': 'eu-west-1',
            'aws_user_pools': 'enable',
            'aws_user_pools_id': 'eu-west-1_uOBPpJKDd',
            'aws_user_pools_mfa_type': 'OPTIONAL',
            'aws_user_pools_web_client_id': '73s14rumbhqp40c5205jrtk68g',
            'aws_user_settings': 'enable',
        };
        break;
    case 'test':
        ApiUrl = 'https://kyqy0sxuy5.execute-api.eu-west-1.amazonaws.com/Prod';
        HCF_URL = 'https://d1qjr7ikpy4ije.cloudfront.net/api';
        SijilatUrl = 'https://slzp68l5j6.execute-api.eu-west-1.amazonaws.com/Prod';
        PaymentUrl = 'https://lfbxwtz3w4.execute-api.eu-west-1.amazonaws.com/Prod';
        QRVerifyUrl = "https://w5cm0c4xag.execute-api.eu-west-1.amazonaws.com/Prod/public/api";
        QuadrabayUrl = "https://testapi.quadrabayapps.com/api";
        WEBSITE_URL = 'https://d26x43rm06hdzh.cloudfront.net/';
        aws_cognito = {
            'aws_cognito_identity_pool_id': 'eu-west-1:b675f1e7-7488-4be0-844b-7443669de3bd',
            'aws_cognito_region': 'eu-west-1',
            'aws_sign_in_enabled': 'enable',
            'aws_user_files': 'enable',
            'aws_user_files_s3_bucket': 'nhra-users-file-storage-dev-bucket',
            'aws_user_files_s3_bucket_region': 'eu-west-1',
            'aws_user_pools': 'enable',
            'aws_user_pools_id': 'eu-west-1_uOBPpJKDd',
            'aws_user_pools_mfa_type': 'OPTIONAL',
            'aws_user_pools_web_client_id': '73s14rumbhqp40c5205jrtk68g',
            'aws_user_settings': 'enable',
        };
        break;
    case 'uat':
        ApiUrl = 'https://zarecmjtn3.execute-api.eu-west-1.amazonaws.com/Prod';
        SijilatUrl = 'https://eoyplzi757.execute-api.eu-west-1.amazonaws.com/Prod';
        PaymentUrl = 'https://2nxrspkc4g.execute-api.eu-west-1.amazonaws.com/Prod';
        QRVerifyUrl = "https://6hbm7nyp36.execute-api.eu-west-1.amazonaws.com/Prod/public/api";
        QuadrabayUrl = "https://testapi.quadrabayapps.com/api";
        HCF_URL = 'https://d1w68q61sokk3v.cloudfront.net/api';
        WEBSITE_URL = 'https://d26x43rm06hdzh.cloudfront.net/';
        aws_cognito = {
            'aws_cognito_identity_pool_id': 'eu-west-1:cfc17f89-fdc9-40c7-8f9b-f224ad921922',
            'aws_cognito_region': 'eu-west-1',
            'aws_sign_in_enabled': 'enable',
            'aws_user_files': 'enable',
            'aws_user_files_s3_bucket': 'nhra-users-file-storage-staging-bucket',
            'aws_user_files_s3_bucket_region': 'eu-west-1',
            'aws_user_pools': 'enable',
            'aws_user_pools_id': 'eu-west-1_5DWm5tuy3',
            'aws_user_pools_mfa_type': 'OPTIONAL',
            'aws_user_pools_web_client_id': '60qj8nc9orldo3sdio5nd9iet4',
            'aws_user_settings': 'enable',
        };
        break;
    case 'production':
        ApiUrl = 'https://m68s8zjzl6.execute-api.eu-west-1.amazonaws.com/Prod';
        HCF_URL = 'https://d755mv9bpwb2t.cloudfront.net/api';
        SijilatUrl = 'https://ehrqeesk2l.execute-api.eu-west-1.amazonaws.com/Prod';
        PaymentUrl = 'https://wc66fd4iwa.execute-api.eu-west-1.amazonaws.com/Prod';
        QRVerifyUrl = "https://lrvjvv8vt0.execute-api.eu-west-1.amazonaws.com/Prod/public/api";
        WEBSITE_URL = 'https://mehan.nhra.bh/';
        aws_cognito = {
            'aws_cognito_identity_pool_id': 'eu-west-1:4f4b292d-93f9-4165-964a-66369eab1d7f',
            'aws_cognito_region': 'eu-west-1',
            'aws_sign_in_enabled': 'enable',
            'aws_user_files': 'enable',
            'aws_user_files_s3_bucket': 'nhra-users-file-storage-prod-bucket',
            'aws_user_files_s3_bucket_region': 'eu-west-1',
            'aws_user_pools': 'enable',
            'aws_user_pools_id': 'eu-west-1_rRYNLOv0O',
            'aws_user_pools_mfa_type': 'OPTIONAL',
            'aws_user_pools_web_client_id': '3rh7vc5167sffpp1qg8m7uc89r',
            'aws_user_settings': 'enable'
        };
        break;
}
